import { responsableLabelForPdf } from '../../../shared/report-pdf/infrastructure/foGesrFieldFormattingCore.ts';
import { createReportPdfFactory } from '../../../shared/report-pdf/factories/createReportPdfFactory.ts';
import type { BuildPuntoEntregaReportPdfOpts } from '../../../shared/report-pdf/punto-entrega-fo-2160/puntoEntregaReportPdfData.ts';
import {
  entregaNombreById,
  lugarNombreByRef,
  type PuntoEntregaReportPdfShellPort,
} from '../../domain/puntoEntregaCatalogLabels.ts';
import type { PuntoEntregaDetail } from '../../domain/puntoEntregaModel.ts';

const reportPdf = createReportPdfFactory();

/**
 * Generates options for building the delivery point PDF report.
 */
function puntoEntregaReportPdfOpts(
  pe: PuntoEntregaReportPdfShellPort,
  detail: PuntoEntregaDetail,
): BuildPuntoEntregaReportPdfOpts {
  const comunaNombre = pe.listComunas().find((c) => c.id === detail.comunaId)?.nombre ?? '—';
  const tiposDoc = pe.listTiposDocumento();
  const nombreTipoDoc = (tipoId: number) => tiposDoc.find((t) => t.id === tipoId)?.nombre ?? '—';
  return {
    entregaNombre: entregaNombreById(pe, detail.entregaId),
    lugarNombre: lugarNombreByRef(pe, detail.lugarId, detail.lugarOrigen),
    comunaNombre,
    resolveParticipanteNombre: (pid) => pe.findParticipanteById(pid)?.nombre ?? `#${pid}`,
    resolveDocumentoYTipoDocumento: (pid) => {
      const pr = pe.findParticipanteById(pid);
      if (!pr) return { documento: '—', tipoDocumento: '—' };
      return {
        documento: pr.documento,
        tipoDocumento: nombreTipoDoc(pr.tipoDocumentoId),
      };
    },
    resolveResponsableNombre: (responsableId) =>
      responsableLabelForPdf(responsableId, detail.responsableNombre),
  };
}
/**
 * Builds the delivery point PDF report using the shell context.
 */
export function buildPuntoEntregaReportPdfFromShell(
  pe: PuntoEntregaReportPdfShellPort,
  detail: PuntoEntregaDetail,
): Promise<Blob> {
  const pdfDetail = {
    ...detail,
  };
  return reportPdf.buildPuntoEntregaFo2160(pdfDetail as any, puntoEntregaReportPdfOpts(pe, detail));
}
